// test.jsx

require('../module.jsx');



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/__tests__/test_root/__testtests__/test.jsx
// module id = 3128
// module chunks = 0